import React from "react";

// Lightweight shimmer skeleton block for content loading (ghost state).
export const Ghost = ({ className = "" }) => (
  <div className={`relative overflow-hidden rounded-2xl bg-white/[0.03] border border-white/5 ${className}`}>
    <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.6s_infinite] bg-gradient-to-r from-transparent via-white/[0.05] to-transparent" />
  </div>
);

export const ProductSkeleton = () => (
  <div className="glass rounded-3xl overflow-hidden">
    <Ghost className="h-56 md:h-64 rounded-none border-0" />
    <div className="p-8 md:p-10 space-y-4">
      <Ghost className="h-6 w-2/3" />
      <Ghost className="h-4 w-full" />
      <div className="grid grid-cols-2 gap-3 pt-4">
        {Array.from({ length: 4 }).map((_, i) => <Ghost key={i} className="h-4 w-full" />)}
      </div>
    </div>
  </div>
);

export const CardSkeleton = ({ h = "h-40" }) => (
  <div className="rounded-3xl border border-white/5 bg-white/[0.015] p-8 space-y-4">
    <Ghost className={`${h} w-full`} />
    <Ghost className="h-4 w-3/4" />
    <Ghost className="h-4 w-1/2" />
  </div>
);

export const RowSkeleton = () => (
  <div className="py-6 border-t border-white/10">
    <Ghost className="h-6 w-1/2" />
  </div>
);
